// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1HtlB","sendOtp":"AuthorizeToLogin_sendOtp__1dleB"};